var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 1.84164C12.8251 1.49997 12.2334 1.73331 12.2334 2.20831V5.11664C12.2334 6.33331 13.2667 7.34164 14.5251 7.34164C15.3167 7.34997 16.4167 7.34997 17.3584 7.34997C17.8334 7.34997 18.0834 6.79164 17.7501 6.45831C16.5501 5.24997 14.4001 3.07497 13.1667 1.84164Z",
    fill: "#8B909A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 8.49169H14.6749C12.6999 8.49169 11.0916 6.88335 11.0916 4.90835V2.50002C11.0916 2.04169 10.7166 1.66669 10.2583 1.66669H6.72492C4.15825 1.66669 2.08325 3.33335 2.08325 6.30835V13.6917C2.08325 16.6667 4.15825 18.3334 6.72492 18.3334H13.2749C15.8416 18.3334 17.9166 16.6667 17.9166 13.6917V9.32502C17.9166 8.86669 17.5416 8.49169 17.0833 8.49169ZM9.58325 14.7917H6.24992C5.90825 14.7917 5.62492 14.5084 5.62492 14.1667C5.62492 13.825 5.90825 13.5417 6.24992 13.5417H9.58325C9.92492 13.5417 10.2083 13.825 10.2083 14.1667C10.2083 14.5084 9.92492 14.7917 9.58325 14.7917ZM11.2499 11.4584H6.24992C5.90825 11.4584 5.62492 11.175 5.62492 10.8334C5.62492 10.4917 5.90825 10.2084 6.24992 10.2084H11.2499C11.5916 10.2084 11.8749 10.4917 11.8749 10.8334C11.8749 11.175 11.5916 11.4584 11.2499 11.4584Z",
    fill: "#8B909A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.6c498e63d995ce455ea36a9ed853fa6c.svg";
export { ForwardRef as ReactComponent };